// extracted by css-extract-rspack-plugin
export default {"Spacer":"BoardWindow-module__Spacer__hJdDF","Metrics":"BoardWindow-module__Metrics__VD03O"};